import { Component, EventEmitter, inject, Input, Output } from "@angular/core";

import { verticalSlideToggle, rotate } from "@shared/animations";
import { LabeledCardComponent } from "@shared/components";
import { GlobalService } from "@shared/services";

@Component({
  selector: "app-accordion",
  standalone: true,
  imports: [LabeledCardComponent],
  templateUrl: "./accordion.component.html",
  styleUrl: "./accordion.component.scss",
  animations: [rotate, verticalSlideToggle],
})
export class AccordionComponent {
  globalService = inject(GlobalService);

  @Input() title: string = "Placeholder";
  @Input() adminOnly: boolean = false;
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  isVisible: boolean = false;

  toggleAccordion() {
    this.visible = !this.visible;
    this.visibleChange.emit(this.visible);
  }
}
